import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../context/I18nContext';

export const Mission = () => {
  const { t } = useTranslation();

  const pillars = ['producers', 'discovery', 'intermediaries', 'technology'];

  return (
    <div className="min-h-screen bg-[#FCFAF8] pt-48 pb-40">
      <div className="container mx-auto px-6 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Header Section */}
          <header className="mb-32 border-b border-zinc-100 pb-20 text-center md:text-left">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="text-5xl md:text-7xl font-medium text-zinc-900 tracking-[-0.02em] mb-10 leading-[1.1]"
            >
              {t('mission.title')}
            </motion.h1>
            <p className="text-xl md:text-2xl text-zinc-400 font-light italic max-w-2xl">
              {t('mission.subtitle')}
            </p>
          </header>

          {/* Intro Section */}
          <section className="mb-32 max-w-3xl">
            <div className="space-y-8">
              <h2 className="text-3xl font-semibold text-zinc-900 tracking-tight">
                {t('mission.intro.title')}
              </h2>
              <p className="text-zinc-500 leading-[1.9] text-xl font-light">
                {t('mission.intro.content')}
              </p>
            </div>
          </section>

          {/* Pillars Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-24 mb-32">
            {pillars.map((key) => (
              <motion.div
                key={key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <div className="w-12 h-px bg-[#D4B483] mb-8" />
                <h3 className="text-xl font-bold text-zinc-900 mb-6 uppercase tracking-wider">
                  {t(`mission.pillars.${key}.title`)}
                </h3>
                <p className="text-zinc-500 leading-relaxed font-light text-lg">
                  {t(`mission.pillars.${key}.content`)}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Closing Statement */}
          <section className="bg-zinc-900 rounded-[3rem] p-12 md:p-24 text-center text-white relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
              <img src="https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&q=80&w=1000" className="w-full h-full object-cover" alt="" />
            </div>
            <p className="text-2xl md:text-3xl font-light italic leading-relaxed relative z-10 max-w-3xl mx-auto">
              "{t('mission.closing')}"
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};